import { useState } from "react";
import styled from "styled-components";

import { DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import { IconButton, Stack, Box, FormHelperText } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "src/components/icon/Image";

import LabelSection from "src/components/core/LabelSection";
import MetaTagComponent from "src/modules/exclusive-deal/MataTagComponent";

import font from "src/styles/font";
import { DarkGrey, GreyStroke, White, White01 } from "src/styles/color";

import { useDialog } from "src/context/DialogContext";
import { useSnackbar } from "notistack";

import { updateSuitableAreaRoom } from "src/api/landingPage";

const BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;

  :last-child {
    margin-bottom: 0;
  }
`;

const S = {};

S.UploadTitle = styled.div`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${DarkGrey};
  margin-bottom: 8px;
`;

S.PreviewImageUploadBox = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  background-color: ${White01};
  border-radius: 16px;
  /* border: 1px solid ${GreyStroke}; */
  /* grid-column: span 7; */
`;

S.UploadInnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.UploadInput = styled.label`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px;
`;

S.UploadLabel = styled.span`
  font-size: ${font.size.sm};
  font-weight: 500;
  color: ${DarkGrey};
  margin-top: 8px;

  &::after {
    content: "*";
    font-weight: 600;
    color: #e04132;
  }
`;

S.UploadHelperText = styled.span`
  display: flex;
  justify-content: center;
  font-size: ${font.size.xs};
  color: ${DarkGrey};
  text-align: center;
  white-space: pre-line;
  margin-top: 8px;
`;

S.UploadedPreviewImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 15px;
  object-fit: cover;
`;

S.BannerListBoxWrapper = styled.div`
  position: relative;
  padding: 24px;
  background-color: ${White01};
  border-radius: 16px;
  margin-top: 24px;
  width: 100%;
  overflow: hidden;
`;

S.BannerListContainer = styled.div`
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin: 0 auto;
`;

S.SellerLogoItem = styled.img`
  width: 160px;
  height: 80px;
  border-radius: 16px;
  background: #d9d9d9;
  object-fit: cover;
  cursor: pointer;
`;

const SuitableAreaRoomEditDialog = ({ initialValue, onClose, onSuccess }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog } = useDialog();

  const [formData, setFormData] = useState(
    initialValue ?? {
      img: null,
      meta_tag: {
        title: "",
        desc: "",
        img: null,
        keywords: "",
      },
    }
  ); // Mapping initial value to form data

  // const isFormValid = ["img"].every((required) => {
  //   let objVal = formData[required];
  //   return objVal !== null && objVal !== "";
  // });

  const isFormValid = true;

  // const isMetaTagValid = ["title", "desc", "img", "keywords"].every(
  //   (required) => {
  //     let objVal = formData?.meta_tag?.[required];
  //     return objVal !== null && objVal !== "";
  //   }
  // );
  const isMetaTagValid = true;

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        meta_tag: {
          title: formData?.meta_tag?.title,
          desc: formData?.meta_tag?.desc,
          keywords: formData?.meta_tag?.keywords,
        },
        meta_img: formData?.meta_tag?.img,
      };

      // const data = new FormData();
      // for (const field in payload) {
      //   if (field === "meta_tag") {
      //     for (const key in payload.meta_tag) {
      //       data.append(`meta_tag.${key}`, payload.meta_tag[key]);
      //     }
      //   } else {
      //     data.append(field, payload[field]);
      //   }
      // }

      await updateSuitableAreaRoom(initialValue?._id, payload); // only update category available

      enqueueSnackbar(`บันทึกสำเร็จ`, {
        variant: "success",
      });

      onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 1024,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        แก้ไข
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="รูปภาพ"
            headerStyle={{ marginBottom: "24px" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <S.PreviewImageUploadBox>
                {!formData?.img ? (
                  <S.UploadInnerBox>
                    <Stack flexDirection={"row"}>
                      <input
                        id="categoryImageHandle"
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          e.preventDefault();
                          setFormData({
                            ...formData,
                            img: e.target.files[0],
                          });
                        }}
                        onClick={(e) => (e.currentTarget.value = null)}
                      />
                      <S.UploadInput htmlFor="categoryImageHandle">
                        <ImageIcon size={24} color={DarkGrey} />
                        <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                        <S.UploadHelperText>
                          {`รูปภาพขนาด 200x200 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                        </S.UploadHelperText>
                      </S.UploadInput>
                    </Stack>
                  </S.UploadInnerBox>
                ) : (
                  <>
                    <S.UploadedPreviewImage
                      src={
                        typeof formData?.img === "string"
                          ? formData?.img
                          : URL.createObjectURL(formData?.img)
                      }
                      alt=""
                    />
                    <Stack
                      sx={{
                        position: "absolute",
                        top: 6,
                        right: 6,
                      }}
                      flexDirection={"row"}
                      columnGap={1}
                    >
                      <IconButton
                        sx={{
                          padding: "4px",
                          backgroundColor: DarkGrey,
                        }}
                        onClick={() => {
                          setFormData({
                            ...formData,
                            img: null,
                          });
                        }}
                      >
                        <CloseIcon sx={{ color: White }} />
                      </IconButton>
                    </Stack>
                  </>
                )}
              </S.PreviewImageUploadBox>
              {!formData?.img && (
                <FormHelperText error={!formData?.img}>
                  กรุณาเลือกรูปภาพ
                </FormHelperText>
              )}
              {/* <Typography
                sx={{
                  mt: 3,
                  alignSelf: "center",
                  fontSize: font.size.sm,
                  color: DarkGrey,
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <InfoRoundedIcon
                  sx={{
                    color: Yellow,
                    mr: 0.5,
                  }}
                />{" "}
                รูปภาพขนาด 1248x287 px ขนาดไฟล์สูงสุดไม่เกิน 4 MB
              </Typography> */}
            </Box>
          </LabelSection>
        </BoxWrapper>

        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="Metatag"
            headerStyle={{ marginBottom: "24px" }}
          >
            <MetaTagComponent
              keyImg="groupMetaTagFieldHandle"
              metatagData={formData?.meta_tag}
              setMetatagData={(val) =>
                setFormData({
                  ...formData,
                  meta_tag: val,
                })
              }
              isEdit={true}
            />
          </LabelSection>
        </BoxWrapper>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{
            minWidth: 160,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            openDialog({
              type: "confirm",
              title: initialValue
                ? `คุณต้องการยืนยันการแก้ไขใช่หรือไม่`
                : `คุณต้องการเพิ่มหมวดหมู่ใช่หรือไม่?`,
              onConfirm: async () => {
                await handleSubmit();
              },
              maxWidth: 342,
            });
          }}
          sx={{
            minWidth: 160,
          }}
          // autoFocus // enable auto focus to increase accessibility
          disabled={!isFormValid || !isMetaTagValid}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuitableAreaRoomEditDialog;
